import React from "react";

function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
    >
      <g
        id="Group_27802"
        data-name="Group 27802"
        transform="translate(14940.225 16925.225)"
      >
        <circle
          id="Ellipse_2005"
          data-name="Ellipse 2005"
          cx="17"
          cy="17"
          r="17"
          transform="translate(-14940.225 -16925.225)"
          fill="#d4e3ed"
        />
        <path
          id="Path_18459"
          data-name="Path 18459"
          d="M12.238,12.238V5H14.65v7.238h7.238V14.65H14.65v7.238H12.238V14.65H5V12.238Z"
          transform="translate(-14936.557 -16921.557)"
          fill="#596970"
        />
      </g>
    </svg>
  );
}

export default PlusIcon;
